import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faHouse } from '@fortawesome/pro-solid-svg-icons/faHouse';
import { faBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding';

import { US } from '../../../constants/country-codes';
import { isResidential } from '../../../enums/residential-indicator';
import style from '../address-validation.module.less';

const AddressValidatedMessage = () => (
  <FormattedMessage defaultMessage='Address Validated' description='addressValidation.addressValidated' id='pza+IL' />
);

const getIcon = (countryCode, residentialIndicator) => {
  if (countryCode !== US) {
    return faGlobe;
  }
  return isResidential(residentialIndicator) ? faHouse : faBuilding;
};

/**
 * @param {object} props
 * @param {string} [props.className] - Optional custom className
 * @param {string} [props.countryCode] - Country code (e.g., 'US', 'CA')
 * @param {string} [props.residentialIndicator] - Residential indicator value
 * @returns {JSX.Element}
 */
const Validated = ({ className = '', countryCode = '', residentialIndicator = '' }) => {
  const icon = getIcon(countryCode, residentialIndicator);
  return (
    <div className={classnames(className, style['address-validated'])}>
      <FontAwesomeIcon icon={icon} />
      <span className={style.validated}>
        <AddressValidatedMessage />
      </span>
    </div>
  );
};

export default Validated;
